class AddToCart {
  constructor() {
    this.button = jQuery('.mad-add-to-cart__button');
    this.button.click(this.handleAddToCart.bind(this));
    this.addToCartEndpoint = 'add_to_cart';
    if (this.button.closest('.mad-add-to-cart').hasClass('mad-add-to-cart--variable')) {
      this.addTo
      this.addToCartEndpoint = 'add_variation_to_cart';
    }

    jQuery(document.body).on( 'added_to_cart removed_from_cart', (e, fragments) => {window.$madUtil.updateFragments(fragments)} );

    jQuery('.mad-side-cart').on('click', '.mad-cart__item-remove', this.removeFromCart.bind(this));
  }

  handleAddToCart(e) {
    e.preventDefault();

    var button = jQuery(e.target).closest('.mad-add-to-cart__button')

    if (button.hasClass('disabled')) return;

    var form = button.closest('form');
    var formData = form.serializeArray();
    var data = {};

    jQuery.each(formData, function (index, item) {
      data[item.name] = item.value;
    });

    var buttonData = {};
    jQuery.each(button[0].dataset, (key, value) => {
      buttonData[key] = value;
    })

    button.removeClass('success')
    button.removeClass('failure')
    
    window.$madUtil.blockElement(button, {icon: {positionX: 'right', size: 'small'}})

    jQuery( document.body ).trigger( 'adding_to_cart', [ button, data ] );

    jQuery.ajax({
      type: 'POST',
      url: wc_add_to_cart_params.wc_ajax_url.toString().replace('%%endpoint%%', this.addToCartEndpoint),
      data: data,
      success: function (response) {
        window.$madUtil.unblockElement(button)
        
        if ( ! response ) {
          return;
        }

        if ( response.error && response.product_url ) {
          window.location = response.product_url;
          return;
        }

        // if ( wc_add_to_cart_params.cart_redirect_after_add === 'yes' ) {
        //   window.location = wc_add_to_cart_params.cart_url;
        //   return;
        // }

        button.addClass('success')

        jQuery( document.body ).trigger( 'added_to_cart', [ response.fragments, response.cart_hash, button ] );
      },
      error: function (jqXHR) {
        // console.log('Error:', jqXHR);
        window.$madUtil.unblockElement(button)
        button.addClass('failure')
      },
      dataType: 'json'
    });
  }

  removeFromCart(e) {

    e.preventDefault();

    var button = jQuery(e.target).closest('.mad-cart__item-remove > a')
    var item = button.closest('.mad-cart__item')
    window.$madUtil.blockElement('.mad-cart', {icon: {size: 'large'}})

    jQuery.ajax({
      type: 'POST',
      url: wc_add_to_cart_params.wc_ajax_url.toString().replace('%%endpoint%%', 'remove_from_cart'),
      data: {
        cart_item_key: button.data('cart_item_key')
      },
      success: function (response) {
        if ( ! response || ! response.fragments ) {
					window.location = button.attr( 'href' );
					return;
				}

        jQuery(document.body).trigger('removed_from_cart', [ response.fragments, response.cart_hash, button ])
        window.$madUtil.unblockElement('.mad-cart')
      },
			error: function() {
				window.location = button.attr( 'href' );
				return;
			},
      dataType: 'json'
    });
  }
}

window.$addToCart = new AddToCart();